import classnames from 'classnames';
import { FunctionComponent } from 'react';

type InstagramProps = {
    className?: string;
};

const Instagram: FunctionComponent<InstagramProps> = props => {
    return (
        <svg
            className={classnames('dibsIcon', props.className)}
            data-tn={'instagram'}
            viewBox="0 0 250 250"
        >
            <path d="M32.2 0h186c17.6 0 32.1 14.5 32.1 32.2v186c0 17.7-14.5 32.1-32.1 32.1h-186C14.5 250.2 0 235.7 0 218.1v-186C0 14.5 14.5 0 32.2 0m150.1 27.9c-6.2 0-11.3 5.1-11.3 11.3v27c0 6.2 5.1 11.3 11.3 11.3h28.3c6.2 0 11.3-5.1 11.3-11.3v-27c0-6.2-5.1-11.3-11.3-11.3h-28.3zm39.6 77.9h-22c2.1 6.8 3.2 14 3.2 21.5 0 41.7-34.8 75.3-77.8 75.3s-77.8-33.7-77.8-75.3c0-7.5 1.1-14.7 3.2-21.5h-23v105.7c0 5.5 4.5 10 10 10h174.2c5.5 0 10-4.5 10-10V105.8zm-96.6-29.9c-27.8 0-50.2 21.8-50.2 48.6s22.4 48.7 50.2 48.7 50.2-21.8 50.2-48.7-22.4-48.6-50.2-48.6" />
        </svg>
    );
};
export default Instagram;
